import { merge } from 'lodash-es';
const def = {
    idAuction: -1,
    idAuctionType: 1,
    evidenceLevel: 1,
    isVisible: false,
    isCloned: false,
    idAuctionParent: null,
    idStatus: 5,
    statusDescription: '',
    startDate: '',
    durationMinutes: 0,
    startDateView: '',
    endDateView: '',
    basePrice: 0.0,
    reservePrice: 0,
    articleQty: 0,
    idEntitySeller: 1,
    entitySellerName: '',
    buyItNow: false,
    embeddedUrl: '',
    article: {
        idArticle: -1,
        idArticleType: 1,
        idDetail: 1,
        idCategory: 1,
        articleDescription: '',
        internalNotes: '',
        articleCertificate: {
            iDCertificate: -1,
            authCertificate: '',
            note: '',
            certificateText: '',
            idTypeCertificate: 1,
        },
        articleTagList: [],
        articleCategoryList: [],
        articlePropertyList: [],
        articlePhotoList: [],
        articlePhoto360List: [],
        articlePhoto360Url: '',
        idSport: null,
        idCompetition: null,
        idTeam: null,
        idSeason: null,
        batchNumber: '',
        donatedBy: '',
        articleInfoList: [
            {
                idLanguage: 1,
                languageCode: 'IT',
                title: '',
                description: '',
                shortDescription: '',
                notes: '',
            },
            {
                idLanguage: 2,
                languageCode: 'EN',
                title: '',
                description: '',
                shortDescription: '',
                notes: '',
            },
        ],
    },
    currentMaxOfferedPrice: null,
    currentMaxIDUserBidder: null,
    currentMaxUsernameBidder: null,
    currentUserOffered: false,
    totalBidder: null,
    totalBids: null,
    isFinished: false,
    idUserWinner: null,
    winnerPrice: null,
    idAutoRebid: null,
    rebidMaxOfferPrice: null,
    idCampaign: null,
    idPromoter: null,
    fullCampaignEntityLogoPath: '',
    fullPromoterLogoPath: '',
    campaignTitleList: [],
    promoterTitleList: [],
    hasReservePrice: false,
    reservePriceReached: false,
    winnerUsername: '',
    idCreatedBy: null,
    idEvent: null,
    eventIsOpen: false,
    createdOn: '0001-01-01T00:00:00',
    idModifiedBy: null,
    modifiedOn: '0001-01-01T00:00:00',
    isPreEvent: false,
    eventTagId: null,
    eventTagDescription: null,
    preEventIdUserWinner: null,
    preEventWinnerUsername: null,
    preEventWinnerPrice: null,
    preEventCloseDate: null,
    inStore: false,
    inHome: false,
    sellerFee: 18,
    idTenantEntity: 1,
};
export function buildAuction(auction) {
    return merge({}, def, auction);
}
